import styled from "styled-components";

export const CurriculumTitleText = styled.h1`
  font-size: 4rem;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
`;
